// Wound type options based on the guide
export const woundTypeOptions = [
  { category: 'Common Chronic Wounds', options: [
    { value: 'DFU', label: 'Diabetic Foot Ulcer (DFU)' },
    { value: 'VLU', label: 'Venous Leg Ulcer (VLU)' },
    { value: 'Pressure Injury (Stage 2-4)', label: 'Pressure Injury (Stage 2-4)' },
    { value: 'Chronic Non-Healing Ulcer', label: 'Chronic Non-Healing Ulcer (Other)' },
  ]},
  { category: 'Post-Procedural / Surgical', options: [
    { value: 'Dehiscent Surgical Wound', label: 'Dehiscent Surgical Wound' },
    { value: 'Post-Debridement Wound', label: 'Post-Debridement Wound' },
    { value: 'Post-Surgical Incision Breakdown', label: 'Post-Surgical Incision Breakdown' },
    { value: 'Non-Healing Surgical Wound', label: 'Non-Healing Surgical Wound' },
  ]},
  { category: 'Traumatic Wounds', options: [
    { value: 'Traumatic Open Wound', label: 'Traumatic Open Wound' },
    { value: 'Skin Tear', label: 'Skin Tear' },
    { value: 'Laceration (Chronic/Non-Healing)', label: 'Laceration (Chronic/Non-Healing)' },
  ]},
  { category: 'Ischemic / Mixed Etiology', options: [
    { value: 'Arterial Ulcer', label: 'Arterial Ulcer' },
    { value: 'Mixed Arterial/Venous Ulcer', label: 'Mixed Arterial/Venous Ulcer' },
  ]},
  { category: 'Other Qualifying Wounds', options: [
    { value: 'Burn Wound (Partial Thickness)', label: 'Burn Wound (Partial Thickness)' },
    { value: 'Radiation-Induced Wound', label: 'Radiation-Induced Wound' },
    { value: 'Lymphedema', label: 'Lymphedema' },
  ]},
];

// Location options filtered by wound type
export const woundLocationMap = {
  'DFU': [
    'Foot → Plantar forefoot',
    'Foot → Plantar midfoot',
    'Foot → Plantar heel',
    'Foot → Dorsal foot',
    'Toe → Great toe',
    'Toe → 2nd toe / 3rd toe / 4th toe / 5th toe',
    'Foot → Lateral foot',
    'Foot → Medial foot',
    'Ankle → Medial malleolus / Lateral malleolus',
  ],
  'VLU': [
    'Lower leg → Medial gaiter area (most common)',
    'Lower leg → Lateral gaiter area',
    'Lower leg → Anterior lower leg',
    'Lower leg → Posterior calf',
    'Ankle → Medial malleolus / Lateral malleolus',
  ],
  'Pressure Injury (Stage 2-4)': [
    'Sacrum/Coccyx',
    'Buttock',
    'Hip/Trochanter',
    'Ischium',
    'Heel',
    'Ankle',
    'Elbow',
    'Shoulder/Scapula',
    'Occiput (back of head)',
  ],
  'Dehiscent Surgical Wound': [
    'Incision site → Abdomen',
    'Incision site → Chest',
    'Incision site → Groin',
    'Incision site → Back',
    'Incision site → Lower extremity (thigh/knee/leg/ankle/foot)',
    'Incision site → Upper extremity (arm/hand)',
    'Amputation site → Toe / Foot / BKA / AKA',
  ],
  'Post-Debridement Wound': [
    'Incision site → Abdomen',
    'Incision site → Chest',
    'Incision site → Groin',
    'Incision site → Back',
    'Incision site → Lower extremity (thigh/knee/leg/ankle/foot)',
    'Incision site → Upper extremity (arm/hand)',
    'Amputation site → Toe / Foot / BKA / AKA',
  ],
  'Post-Surgical Incision Breakdown': [
    'Incision site → Abdomen',
    'Incision site → Chest',
    'Incision site → Groin',
    'Incision site → Back',
    'Incision site → Lower extremity (thigh/knee/leg/ankle/foot)',
    'Incision site → Upper extremity (arm/hand)',
    'Amputation site → Toe / Foot / BKA / AKA',
  ],
  'Non-Healing Surgical Wound': [
    'Incision site → Abdomen',
    'Incision site → Chest',
    'Incision site → Groin',
    'Incision site → Back',
    'Incision site → Lower extremity (thigh/knee/leg/ankle/foot)',
    'Incision site → Upper extremity (arm/hand)',
    'Amputation site → Toe / Foot / BKA / AKA',
  ],
  'Amputation Site (Non-Healing)': [
    'Amputation site → Toe / Foot / BKA / AKA',
  ],
  'Traumatic Open Wound': [
  ],
  'Skin Tear': [
  ],
  'Laceration (Chronic/Non-Healing)': [
  ],
  'Arterial Ulcer': [
  ],
  'Mixed Arterial/Venous Ulcer': [
  ],
  'Chronic Non-Healing Ulcer': [
    
  ],
  'Burn Wound (Partial Thickness)': [
    
  ],
  'Radiation-Induced Wound': [
    
  ],
  'Lymphedema': [
  'A6530 - Knee High Compression Socks',
  'A6533 - Thigh High Compression Socks',
  'A6587 Gradient Compression Foot Wrap w/ Adjustable Straps Left Foot',
  'A6587 Gradient Compression Foot Wrap w/Adjustable Straps Right Foot',
  'A6583 Gradient Compression Calf Wrap w/ Adjustable Straps Left Calf',
  'A6583 Gradient Compression Calf Wrap w/Adjustable Straps Right Calf',
  'A6585 Gradient Compression Knee Wrap w/ Adjustable Straps Left Knee',
  'A6585 Gradient Compression Knee Wrap w/Adjustable Straps Right Knee',
  'A6585 Gradient Compression Thigh Wrap w/ Adjustable Straps Left Thigh',
  'A6585 Gradient Compression Thigh Wrap w/Adjustable Straps Right Thigh',
  'A6586 Gradient Compression Full Leg Wrap w/Adjustable Straps Left Leg',
  'A6586 Gradient Compression Full Leg Wrap w/Adjustable Straps Right Leg',
  'E0651 and E0667 - Pneumatic Compression Pump for Lymphedema',
],
};


// ICD-10 Codes
// conservativeCareData.js - Fix icd10Codes format

export const icd10Codes = [
  {code: "T81.31XA", description: ""},
  { code: "I89.0", description: "Lymphedema, not elsewhere classified" },
  { code: "Q82.0", description: "Hereditary Lymphedema" },
  { code: "I87.2", description: "Peripheral Venous Insufficiency" },
  { code: "R60.0", description: "Localized Edema" },
  { code: "I83.813", description: "Varicose Veins with pain" },
  { code: "I87.1", description: "Compression of Vein" },
  { code: "I83.001", description: "Varicose veins of unspecified lower extremity with ulcer of thigh" },
  { code: "I83.002", description: "Varicose veins of unspecified lower extremity with ulcer of calf" },
  { code: "I83.003", description: "Varicose veins of unspecified lower extremity with ulcer of ankle" },
  { code: "I83.004", description: "Varicose veins of unspecified lower extremity with ulcer of heel and midfoot" },
  { code: "I83.005", description: "Varicose veins of unspecified lower extremity with ulcer other part of foot" },
  { code: "I83.008", description: "Varicose veins of unspecified lower extremity with ulcer other part of lower leg" },
  { code: "I83.009", description: "Varicose veins of unspecified lower extremity with ulcer of unspecified site" },
  { code: "I83.011", description: "Varicose veins of right lower extremity with ulcer of thigh" },
  { code: "I83.012", description: "Varicose veins of right lower extremity with ulcer of calf" },
  { code: "I83.013", description: "Varicose veins of right lower extremity with ulcer of ankle" },
  { code: "I83.014", description: "Varicose veins of right lower extremity with ulcer of heel and midfoot" },
  { code: "I83.015", description: "Varicose veins of right lower extremity with ulcer other part of foot" },
  { code: "I83.018", description: "Varicose veins of right lower extremity with ulcer other part of lower leg" },
  { code: "I83.019", description: "Varicose veins of right lower extremity with ulcer of unspecified site" },
  { code: "I83.021", description: "Varicose veins of left lower extremity with ulcer of thigh" },
  { code: "I83.022", description: "Varicose veins of left lower extremity with ulcer of calf" },
  { code: "I83.023", description: "mity with ulcer of ankle" },
  { code: "I83.024", description: "Varicose veins of left lower extremity with ulcer of heel and midfoot" },
  { code: "I83.025", description: "Varicose veins of left lower extremity with ulcer other part of foot" },
  { code: "I83.028", description: "Varicose veins of left lower extremity with ulcer other part of lower leg" },
  { code: "I83.029", description: "Varicose veins of left lower extremity with ulcer of unspecified site" },
  { code: "I83.201", description: "Varicose veins of unspecified lower extremity with both ulcer of thigh and inflammation" },
  { code: "I83.202", description: "Varicose veins of unspecified lower extremity with both ulcer of calf and inflammation" },
  { code: "I83.203", description: "Varicose veins of unspecified lower extremity with both ulcer of ankle and inflammation" },
  { code: "I83.204", description: "Varicose veins of unspecified lower extremity with both ulcer of heel and midfoot and inflammation" },
  { code: "I83.205", description: "Varicose veins of unspecified lower extremity with both ulcer other part of foot and inflammation" },
  { code: "I83.208", description: "Varicose veins of unspecified lower extremity with both ulcer of other part of lower extremity and inflammation" },
  { code: "I83.209", description: "Varicose veins of unspecified lower extremity with both ulcer of unspecified site and inflammation" },
  { code: "I83.211", description: "Varicose veins of right lower extremity with both ulcer of thigh and inflammation" },
  { code: "I83.212", description: "Varicose veins of right lower extremity with both ulcer of calf and inflammation" },
  { code: "I83.213", description: "Varicose veins of right lower extremity with both ulcer of ankle and inflammation" },
  { code: "I83.214", description: "Varicose veins of right lower extremity with both ulcer of heel and midfoot and inflammation" },
  { code: "I83.215", description: "Varicose veins of right lower extremity with both ulcer other part of foot and inflammation" },
  { code: "I83.218", description: "Varicose veins of right lower extremity with both ulcer of other part of lower extremity and inflammation" },
  { code: "I83.219", description: "Varicose veins of right lower extremity with both ulcer of unspecified site and inflammation" },
  { code: "I83.221", description: "Varicose veins of left lower extremity with both ulcer of thigh and inflammation" },
  { code: "I83.222", description: "Varicose veins of left lower extremity with both ulcer of calf and inflammation" },
  { code: "I83.223", description: "Varicose veins of left lower extremity with both ulcer of ankle and inflammation" },
  { code: "I83.224", description: "Varicose veins of left lower extremity with both ulcer of heel and midfoot and inflammation" },
  { code: "I83.225", description: "Varicose veins of left lower extremity with both ulcer other part of foot and inflammation" },
  { code: "I83.228", description: "Varicose veins of left lower extremity with both ulcer of other part of lower extremity and inflammation" },
  { code: "I83.229", description: "Varicose veins of left lower extremity with both ulcer of unspecified site and inflammation" },
  { code: "I87.011", description: "Postthrombotic syndrome with ulcer of right lower extremity" },
  { code: "I87.012", description: "Postthrombotic syndrome with ulcer of left lower extremity" },
  { code: "I87.013", description: "Postthrombotic syndrome with ulcer of bilateral lower extremity" },
  { code: "I87.019", description: "Postthrombotic syndrome with ulcer of unspecified lower extremity" },
  { code: "I87.031", description: "Postthrombotic syndrome with ulcer and inflammation of right lower extremity" },
  { code: "I87.032", description: "Postthrombotic syndrome with ulcer and inflammation of left lower extremity" },
  { code: "I87.033", description: "Postthrombotic syndrome with ulcer and inflammation of bilateral lower extremity" },
  { code: "I87.039", description: "Postthrombotic syndrome with ulcer and inflammation of unspecified lower extremity" },
  { code: "I87.2", description: "Venous insufficiency (chronic) (peripheral)" },
  { code: "I87.311", description: "Chronic venous hypertension (idiopathic) with ulcer of right lower extremity" },
  { code: "I87.312", description: "Chronic venous hypertension (idiopathic) with ulcer of left lower extremity" },
  { code: "I87.313", description: "Chronic venous hypertension (idiopathic) with ulcer of bilateral lower extremity" },
  { code: "I87.319", description: "Chronic venous hypertension (idiopathic) with ulcer of unspecified lower extremity" },
  { code: "I87.331", description: "Chronic venous hypertension (idiopathic) with ulcer and inflammation of right lower extremity" },
  { code: "I87.332", description: "Chronic venous hypertension (idiopathic) with ulcer and inflammation of left lower extremity" },
  { code: "I87.333", description: "Chronic venous hypertension (idiopathic) with ulcer and inflammation of bilateral lower extremity" },
  { code: "I87.339", description: "Chronic venous hypertension (idiopathic) with ulcer and inflammation of unspecified lower extremity" },
  { code: "L97.101", description: "Non-pressure chronic ulcer of unspecified thigh limited to breakdown of skin" },
  { code: "L97.102", description: "Non-pressure chronic ulcer of unspecified thigh with fat layer exposed" },
  { code: "L97.103", description: "Non-pressure chronic ulcer of unspecified thigh with necrosis of muscle" },
  { code: "L97.104", description: "Non-pressure chronic ulcer of unspecified thigh with necrosis of bone" },
  { code: "L97.109", description: "Non-pressure chronic ulcer of unspecified thigh with unspecified severity" },
  { code: "L97.111", description: "Non-pressure chronic ulcer of right thigh limited to breakdown of skin" },
  { code: "L97.112", description: "Non-pressure chronic ulcer of right thigh with fat layer exposed" },
  { code: "L97.113", description: "Non-pressure chronic ulcer of right thigh with necrosis of muscle" },
  { code: "L97.114", description: "Non-pressure chronic ulcer of right thigh with necrosis of bone" },
  { code: "L97.119", description: "Non-pressure chronic ulcer of right thigh with unspecified severity" },
  { code: "L97.121", description: "Non-pressure chronic ulcer of left thigh limited to breakdown of skin" },
  { code: "L97.122", description: "Non-pressure chronic ulcer of left thigh with fat layer exposed" },
  { code: "L97.123", description: "Non-pressure chronic ulcer of left thigh with necrosis of muscle" },
  { code: "L97.124", description: "Non-pressure chronic ulcer of left thigh with necrosis of bone" },
  { code: "L97.129", description: "Non-pressure chronic ulcer of left thigh with unspecified severity" },
  { code: "L97.201", description: "Non-pressure chronic ulcer of unspecified calf limited to breakdown of skin" },
  { code: "L97.202", description: "Non-pressure chronic ulcer of unspecified calf with fat layer exposed" },
  { code: "L97.203", description: "Non-pressure chronic ulcer of unspecified calf with necrosis of muscle" },
  { code: "L97.204", description: "Non-pressure chronic ulcer of unspecified calf with necrosis of bone" },
  { code: "L97.209", description: "Non-pressure chronic ulcer of unspecified calf with unspecified severity" },
  { code: "L97.211", description: "Non-pressure chronic ulcer of right calf limited to breakdown of skin" },
  { code: "L97.212", description: "Non-pressure chronic ulcer of right calf with fat layer exposed" },
  { code: "L97.213", description: "Non-pressure chronic ulcer of right calf with necrosis of muscle" },
  { code: "L97.214", description: "Non-pressure chronic ulcer of right calf with necrosis of bone" },
  { code: "L97.219", description: "Non-pressure chronic ulcer of right calf with unspecified severity" },
  { code: "L97.221", description: "Non-pressure chronic ulcer of left calf limited to breakdown of skin" },
  { code: "L97.222", description: "Non-pressure chronic ulcer of left calf with fat layer exposed" },
  { code: "L97.223", description: "Non-pressure chronic ulcer of left calf with necrosis of muscle" },
  { code: "L97.224", description: "Non-pressure chronic ulcer of left calf with necrosis of bone" },
  { code: "L97.229", description: "Non-pressure chronic ulcer of left calf with unspecified severity" },
  { code: "L97.301", description: "Non-pressure chronic ulcer of unspecified ankle limited to breakdown of skin" },
  { code: "L97.302", description: "Non-pressure chronic ulcer of unspecified ankle with fat layer exposed" },
  { code: "L97.303", description: "Non-pressure chronic ulcer of unspecified ankle with necrosis of muscle" },
  { code: "L97.304", description: "Non-pressure chronic ulcer of unspecified ankle with necrosis of bone" },
  { code: "L97.309", description: "Non-pressure chronic ulcer of unspecified ankle with unspecified severity" },
  { code: "L97.311", description: "Non-pressure chronic ulcer of right ankle limited to breakdown of skin" },
  { code: "L97.312", description: "Non-pressure chronic ulcer of right ankle with fat layer exposed" },
  { code: "L97.313", description: "Non-pressure chronic ulcer of right ankle with necrosis of muscle" },
  { code: "L97.314", description: "Non-pressure chronic ulcer of right ankle with necrosis of bone" },
  { code: "L97.319", description: "Non-pressure chronic ulcer of right ankle with unspecified severity" },
  { code: "L97.321", description: "Non-pressure chronic ulcer of left ankle limited to breakdown of skin" },
  { code: "L97.322", description: "Non-pressure chronic ulcer of left ankle with fat layer exposed" },
  { code: "L97.323", description: "Non-pressure chronic ulcer of left ankle with necrosis of muscle" },
  { code: "L97.324", description: "Non-pressure chronic ulcer of left ankle with necrosis of bone" },
  { code: "L97.329", description: "Non-pressure chronic ulcer of left ankle with unspecified severity" },
  { code: "L97.401", description: "Non-pressure chronic ulcer of unspecified heel and midfoot limited to breakdown of skin" },
  { code: "L97.402", description: "Non-pressure chronic ulcer of unspecified heel and midfoot with fat layer exposed" },
  { code: "L97.403", description: "Non-pressure chronic ulcer of unspecified heel and midfoot with necrosis of muscle" },
  { code: "L97.404", description: "Non-pressure chronic ulcer of unspecified heel and midfoot with necrosis of bone" },
  { code: "L97.409", description: "Non-pressure chronic ulcer of unspecified heel and midfoot with unspecified severity" },
  { code: "L97.411", description: "Non-pressure chronic ulcer of right heel and midfoot limited to breakdown of skin" },
  { code: "L97.412", description: "Non-pressure chronic ulcer of right heel and midfoot with fat layer exposed" },
  { code: "L97.413", description: "Non-pressure chronic ulcer of right heel and midfoot with necrosis of muscle" },
  { code: "L97.414", description: "Non-pressure chronic ulcer of right heel and midfoot with necrosis of bone" },
  { code: "L97.419", description: "Non-pressure chronic ulcer of right heel and midfoot with unspecified severity" },
  { code: "L97.421", description: "Non-pressure chronic ulcer of left heel and midfoot limited to breakdown of skin" },
  { code: "L97.422", description: "Non-pressure chronic ulcer of left heel and midfoot with fat layer exposed" },
  { code: "L97.423", description: "Non-pressure chronic ulcer of left heel and midfoot with necrosis of muscle" },
  { code: "L97.424", description: "Non-pressure chronic ulcer of left heel and midfoot with necrosis of bone" },
  { code: "L97.429", description: "Non-pressure chronic ulcer of left heel and midfoot with unspecified severity" },
  { code: "L97.501", description: "Non-pressure chronic ulcer of other part of unspecified foot limited to breakdown of skin" },
  { code: "L97.502", description: "Non-pressure chronic ulcer of other part of unspecified foot with fat layer exposed" },
  { code: "L97.503", description: "Non-pressure chronic ulcer of other part of unspecified foot with necrosis of muscle" },
  { code: "L97.504", description: "Non-pressure chronic ulcer of other part of unspecified foot with necrosis of bone" },
  { code: "L97.509", description: "Non-pressure chronic ulcer of other part of unspecified foot with unspecified severity" },
  { code: "L97.511", description: "Non-pressure chronic ulcer of other part of right foot limited to breakdown of skin" },
  { code: "L97.512", description: "Non-pressure chronic ulcer of other part of right foot with fat layer exposed" },
  { code: "L97.513", description: "Non-pressure chronic ulcer of other part of right foot with necrosis of muscle" },
  { code: "L97.514", description: "Non-pressure chronic ulcer of other part of right foot with necrosis of bone" },
  { code: "L97.519", description: "Non-pressure chronic ulcer of other part of right foot with unspecified severity" },
  { code: "L97.521", description: "Non-pressure chronic ulcer of other part of left foot limited to breakdown of skin" },
  { code: "L97.522", description: "Non-pressure chronic ulcer of other part of left foot with fat layer exposed" },
  { code: "L97.523", description: "Non-pressure chronic ulcer of other part of left foot with necrosis of muscle" },
  { code: "L97.524", description: "Non-pressure chronic ulcer of other part of left foot with necrosis of bone" },
  { code: "L97.529", description: "Non-pressure chronic ulcer of other part of left foot with unspecified severity" },
  { code: "L97.801", description: "Non-pressure chronic ulcer of other part of unspecified lower leg limited to breakdown of skin" },
  { code: "L97.802", description: "Non-pressure chronic ulcer of other part of unspecified lower leg with fat layer exposed" },
  { code: "L97.803", description: "Non-pressure chronic ulcer of other part of unspecified lower leg with necrosis of muscle" },
  { code: "L97.804", description: "Non-pressure chronic ulcer of other part of unspecified lower leg with necrosis of bone" },
  { code: "L97.809", description: "Non-pressure chronic ulcer of other part of unspecified lower leg with unspecified severity" },
  { code: "L97.811", description: "Non-pressure chronic ulcer of other part of right lower leg limited to breakdown of skin" },
  { code: "L97.812", description: "Non-pressure chronic ulcer of other part of right lower leg with fat layer exposed" },
  { code: "L97.813", description: "Non-pressure chronic ulcer of other part of right lower leg with necrosis of muscle" },
  { code: "L97.814", description: "Non-pressure chronic ulcer of other part of right lower leg with necrosis of bone" },
  { code: "L97.819", description: "Non-pressure chronic ulcer of other part of right lower leg with unspecified severity" },
  { code: "L97.821", description: "Non-pressure chronic ulcer of other part of left lower leg limited to breakdown of skin" },
  { code: "L97.822", description: "Non-pressure chronic ulcer of other part of left lower leg with fat layer exposed" },
  { code: "L97.823", description: "Non-pressure chronic ulcer of other part of left lower leg with necrosis of muscle" },
  { code: "L97.824", description: "Non-pressure chronic ulcer of other part of left lower leg with necrosis of bone" },
  { code: "L97.829", description: "Non-pressure chronic ulcer of other part of left lower leg with unspecified severity" },
  { code: "L97.901", description: "Non-pressure chronic ulcer of unspecified part of unspecified lower leg limited to breakdown of skin" },
  { code: "L97.902", description: "Non-pressure chronic ulcer of unspecified part of unspecified lower leg with fat layer exposed" },
  { code: "L97.903", description: "Non-pressure chronic ulcer of unspecified part of unspecified lower leg with necrosis of muscle" },
  { code: "L97.904", description: "Non-pressure chronic ulcer of unspecified part of unspecified lower leg with necrosis of bone" },
  { code: "L97.909", description: "Non-pressure chronic ulcer of unspecified part of unspecified lower leg with unspecified severity" },
  { code: "L97.911", description: "Non-pressure chronic ulcer of unspecified part of right lower leg limited to breakdown of skin" },
  { code: "L97.912", description: "Non-pressure chronic ulcer of unspecified part of right lower leg with fat layer exposed" },
  { code: "L97.913", description: "Non-pressure chronic ulcer of unspecified part of right lower leg with necrosis of muscle" },
  { code: "L97.914", description: "Non-pressure chronic ulcer of unspecified part of right lower leg with necrosis of bone" },
  { code: "L97.919", description: "Non-pressure chronic ulcer of unspecified part of right lower leg with unspecified severity" },
  { code: "L97.921", description: "Non-pressure chronic ulcer of unspecified part of left lower leg limited to breakdown of skin" },
  { code: "L97.922", description: "Non-pressure chronic ulcer of unspecified part of left lower leg with fat layer exposed" },
  { code: "L97.923", description: "Non-pressure chronic ulcer of unspecified part of left lower leg with necrosis of muscle" },
  { code: "L97.924", description: "Non-pressure chronic ulcer of unspecified part of left lower leg with necrosis of bone" },
  { code: "L97.929", description: "Non-pressure chronic ulcer of unspecified part of left lower leg with unspecified severity" },
  { code: "L98.411", description: "Non-pressure chronic ulcer of buttock limited to breakdown of skin" },
  { code: "L98.412", description: "Non-pressure chronic ulcer of buttock with fat layer exposed" },
  { code: "L98.413", description: "Non-pressure chronic ulcer of buttock with necrosis of muscle" },
  { code: "L98.414", description: "Non-pressure chronic ulcer of buttock with necrosis of bone" },
  { code: "L98.419", description: "Non-pressure chronic ulcer of buttock with unspecified severity" },
  { code: "L98.421", description: "Non-pressure chronic ulcer of back limited to breakdown of skin" },
  { code: "L98.422", description: "Non-pressure chronic ulcer of back with fat layer exposed" },
  { code: "L98.423", description: "Non-pressure chronic ulcer of back with necrosis of muscle" },
  { code: "L98.424", description: "Non-pressure chronic ulcer of back with necrosis of bone" },
  { code: "L98.429", description: "Non-pressure chronic ulcer of back with unspecified severity" },
  { code: "L98.491", description: "Non-pressure chronic ulcer of skin of other sites limited to breakdown of skin" },
  { code: "L98.492", description: "Non-pressure chronic ulcer of skin of other sites with fat layer exposed" },
  { code: "L98.493", description: "Non-pressure chronic ulcer of skin of other sites with necrosis of muscle" },
  { code: "L98.494", description: "Non-pressure chronic ulcer of skin of other sites with necrosis of bone" },
  { code: "L98.499", description: "Non-pressure chronic ulcer of skin of other sites with unspecified severity" },
  { code: "E08.621", description: "Diabetes mellitus due to underlying condition with foot ulcer" },
  { code: "E08.622", description: "Diabetes mellitus due to underlying condition with other skin ulcer" },
  { code: "E09.621", description: "Drug or chemical induced diabetes mellitus with foot ulcer" },
  { code: "E09.622", description: "Drug or chemical induced diabetes mellitus with other skin ulcer" },
  { code: "E10.621", description: "Type 1 diabetes mellitus with foot ulcer" },
  { code: "E10.622", description: "Type 1 diabetes mellitus with other skin ulcer" },
  { code: "E11.621", description: "Type 2 diabetes mellitus with foot ulcer" },
  { code: "E11.622", description: "Type 2 diabetes mellitus with other skin ulcer" },
  { code: "E13.621", description: "Other specified diabetes mellitus with foot ulcer" },
  { code: "E13.622", description: "Other specified diabetes mellitus with other skin ulcer" },
  { code: "L89.000", description: "Pressure ulcer of unspecified elbow, unstageable" },
  { code: "L89.001", description: "Pressure ulcer of unspecified elbow, stage 1" },
  { code: "L89.002", description: "Pressure ulcer of unspecified elbow, stage 2" },
  { code: "L89.003", description: "Pressure ulcer of unspecified elbow, stage 3" },
  { code: "L89.004", description: "Pressure ulcer of unspecified elbow, stage 4" },
  { code: "L89.009", description: "Pressure ulcer of unspecified elbow, unspecified stage" },
  { code: "L89.010", description: "Pressure ulcer of right elbow, unstageable" },
  { code: "L89.011", description: "Pressure ulcer of right elbow, stage 1" },
  { code: "L89.012", description: "Pressure ulcer of right elbow, stage 2" },
  { code: "L89.013", description: "Pressure ulcer of right elbow, stage 3" },
  { code: "L89.014", description: "Pressure ulcer of right elbow, stage 4" },
  { code: "L89.019", description: "Pressure ulcer of right elbow, unspecified stage" },
  { code: "L89.020", description: "Pressure ulcer of left elbow, unstageable" },
  { code: "L89.021", description: "Pressure ulcer of left elbow, stage 1" },
  { code: "L89.022", description: "Pressure ulcer of left elbow, stage 2" },
  { code: "L89.023", description: "Pressure ulcer of left elbow, stage 3" },
  { code: "L89.024", description: "Pressure ulcer of left elbow, stage 4" },
  { code: "L89.029", description: "Pressure ulcer of left elbow, unspecified stage" },
  { code: "L89.100", description: "Pressure ulcer of unspecified part of back, unstageable" },
  { code: "L89.101", description: "Pressure ulcer of unspecified part of back, stage 1" },
  { code: "L89.102", description: "Pressure ulcer of unspecified part of back, stage 2" },
  { code: "L89.103", description: "Pressure ulcer of unspecified part of back, stage 3" },
  { code: "L89.104", description: "Pressure ulcer of unspecified part of back, stage 4" },
  { code: "L89.109", description: "Pressure ulcer of unspecified part of back, unspecified stage" },
  { code: "L89.110", description: "Pressure ulcer of right upper back, unstageable" },
  { code: "L89.111", description: "Pressure ulcer of right upper back, stage 1" },
  { code: "L89.112", description: "Pressure ulcer of right upper back, stage 2" },
  { code: "L89.113", description: "Pressure ulcer of right upper back, stage 3" },
  { code: "L89.114", description: "Pressure ulcer of right upper back, stage 4" },
  { code: "L89.119", description: "Pressure ulcer of right upper back, unspecified stage" },
  { code: "L89.120", description: "Pressure ulcer of left upper back, unstageable" },
  { code: "L89.121", description: "Pressure ulcer of left upper back, stage 1" },
  { code: "L89.122", description: "Pressure ulcer of left upper back, stage 2" },
  { code: "L89.123", description: "Pressure ulcer of left upper back, stage 3" },
  { code: "L89.124", description: "Pressure ulcer of left upper back, stage 4" },
  { code: "L89.129", description: "Pressure ulcer of left upper back, unspecified stage" },
  { code: "L89.130", description: "Pressure ulcer of right lower back, unstageable" },
  { code: "L89.131", description: "Pressure ulcer of right lower back, stage 1" },
  { code: "L89.132", description: "Pressure ulcer of right lower back, stage 2" },
  { code: "L89.133", description: "Pressure ulcer of right lower back, stage 3" },
  { code: "L89.134", description: "Pressure ulcer of right lower back, stage 4" },
  { code: "L89.139", description: "Pressure ulcer of right lower back, unspecified stage" },
  { code: "L89.140", description: "Pressure ulcer of left lower back, unstageable" },
  { code: "L89.141", description: "Pressure ulcer of left lower back, stage 1" },
  { code: "L89.142", description: "Pressure ulcer of left lower back, stage 2" },
  { code: "L89.143", description: "Pressure ulcer of left lower back, stage 3" },
  { code: "L89.144", description: "Pressure ulcer of left lower back, stage 4" },
  { code: "L89.149", description: "Pressure ulcer of left lower back, unspecified stage" },
  { code: "L89.150", description: "Pressure ulcer of sacral region, unstageable" },
  { code: "L89.151", description: "Pressure ulcer of sacral region, stage 1" },
  { code: "L89.152", description: "Pressure ulcer of sacral region, stage 2" },
  { code: "L89.153", description: "Pressure ulcer of sacral region, stage 3" },
  { code: "L89.154", description: "Pressure ulcer of sacral region, stage 4" },
  { code: "L89.159", description: "Pressure ulcer of sacral region, unspecified stage" },
  { code: "L89.200", description: "Pressure ulcer of unspecified hip, unstageable" },
  { code: "L89.201", description: "Pressure ulcer of unspecified hip, stage 1" },
  { code: "L89.202", description: "Pressure ulcer of unspecified hip, stage 2" },
  { code: "L89.203", description: "Pressure ulcer of unspecified hip, stage 3" },
  { code: "L89.204", description: "Pressure ulcer of unspecified hip, stage 4" },
  { code: "L89.209", description: "Pressure ulcer of unspecified hip, unspecified stage" },
  { code: "L89.210", description: "Pressure ulcer of right hip, unstageable" },
  { code: "L89.211", description: "Pressure ulcer of right hip, stage 1" },
  { code: "L89.212", description: "Pressure ulcer of right hip, stage 2" },
  { code: "L89.213", description: "Pressure ulcer of right hip, stage 3" },
  { code: "L89.214", description: "Pressure ulcer of right hip, stage 4" },
  { code: "L89.219", description: "Pressure ulcer of right hip, unspecified stage" },
  { code: "L89.220", description: "Pressure ulcer of left hip, unstageable" },
  { code: "L89.221", description: "Pressure ulcer of left hip, stage 1" },
  { code: "L89.222", description: "Pressure ulcer of left hip, stage 2" },
  { code: "L89.223", description: "Pressure ulcer of left hip, stage 3" },
  { code: "L89.224", description: "Pressure ulcer of left hip, stage 4" },
  { code: "L89.229", description: "Pressure ulcer of left hip, unspecified stage" },
  { code: "L89.300", description: "Pressure ulcer of unspecified buttock, unstageable" },
  { code: "L89.301", description: "Pressure ulcer of unspecified buttock, stage 1" },
  { code: "L89.302", description: "Pressure ulcer of unspecified buttock, stage 2" },
  { code: "L89.303", description: "Pressure ulcer of unspecified buttock, stage 3" },
  { code: "L89.304", description: "Pressure ulcer of unspecified buttock, stage 4" },
  { code: "L89.309", description: "Pressure ulcer of unspecified buttock, unspecified stage" },
  { code: "L89.310", description: "Pressure ulcer of right buttock, unstageable" },
  { code: "L89.311", description: "Pressure ulcer of right buttock, stage 1" },
  { code: "L89.312", description: "Pressure ulcer of right buttock, stage 2" },
  { code: "L89.313", description: "Pressure ulcer of right buttock, stage 3" },
  { code: "L89.314", description: "Pressure ulcer of right buttock, stage 4" },
  { code: "L89.319", description: "Pressure ulcer of right buttock, unspecified stage" },
  { code: "L89.320", description: "Pressure ulcer of left buttock, unstageable" },
  { code: "L89.321", description: "Pressure ulcer of left buttock, stage 1" },
  { code: "L89.322", description: "Pressure ulcer of left buttock, stage 2" },
  { code: "L89.323", description: "Pressure ulcer of left buttock, stage 3" },
  { code: "L89.324", description: "Pressure ulcer of left buttock, stage 4" },
  { code: "L89.329", description: "Pressure ulcer of left buttock, unspecified stage" },
  { code: "L89.40", description: "Pressure ulcer of contiguous site of back, buttock and hip, unspecified stage" },
  { code: "L89.41", description: "Pressure ulcer of contiguous site of back, buttock and hip, stage 1" },
  { code: "L89.42", description: "Pressure ulcer of contiguous site of back, buttock and hip, stage 2" },
  { code: "L89.43", description: "Pressure ulcer of contiguous site of back, buttock and hip, stage 3" },
  { code: "L89.44", description: "Pressure ulcer of contiguous site of back, buttock and hip, stage 4" },
  { code: "L89.45", description: "Pressure ulcer of contiguous site of back, buttock and hip, unstageable" },
  { code: "L89.500", description: "Pressure ulcer of unspecified ankle, unstageable" },
  { code: "L89.501", description: "Pressure ulcer of unspecified ankle, stage 1" },
  { code: "L89.502", description: "Pressure ulcer of unspecified ankle, stage 2" },
  { code: "L89.503", description: "Pressure ulcer of unspecified ankle, stage 3" },
  { code: "L89.504", description: "Pressure ulcer of unspecified ankle, stage 4" },
  { code: "L89.509", description: "Pressure ulcer of unspecified ankle, unspecified stage" },
  { code: "L89.510", description: "Pressure ulcer of right ankle, unstageable" },
  { code: "L89.511", description: "Pressure ulcer of right ankle, stage 1" },
  { code: "L89.512", description: "Pressure ulcer of right ankle, stage 2" },
  { code: "L89.513", description: "Pressure ulcer of right ankle, stage 3" },
  { code: "L89.514", description: "Pressure ulcer of right ankle, stage 4" },
  { code: "L89.519", description: "Pressure ulcer of right ankle, unspecified stage" },
  { code: "L89.520", description: "Pressure ulcer of left ankle, unstageable" },
  { code: "L89.521", description: "Pressure ulcer of left ankle, stage 1" },
  { code: "L89.522", description: "Pressure ulcer of left ankle, stage 2" },
  { code: "L89.523", description: "Pressure ulcer of left ankle, stage 3" },
  { code: "L89.524", description: "Pressure ulcer of left ankle, stage 4" },
  { code: "L89.529", description: "Pressure ulcer of left ankle, unspecified stage" },
  { code: "L89.600", description: "Pressure ulcer of unspecified heel, unstageable" },
  { code: "L89.601", description: "Pressure ulcer of unspecified heel, stage 1" },
  { code: "L89.602", description: "Pressure ulcer of unspecified heel, stage 2" },
  { code: "L89.603", description: "Pressure ulcer of unspecified heel, stage 3" },
  { code: "L89.604", description: "Pressure ulcer of unspecified heel, stage 4" },
  { code: "L89.609", description: "Pressure ulcer of unspecified heel, unspecified stage" },
  { code: "L89.610", description: "Pressure ulcer of right heel, unstageable" },
  { code: "L89.611", description: "Pressure ulcer of right heel, stage 1" },
  { code: "L89.612", description: "Pressure ulcer of right heel, stage 2" },
  { code: "L89.613", description: "Pressure ulcer of right heel, stage 3" },
  { code: "L89.614", description: "Pressure ulcer of right heel, stage 4" },
  { code: "L89.619", description: "Pressure ulcer of right heel, unspecified stage" },
  { code: "L89.620", description: "Pressure ulcer of left heel, unstageable" },
  { code: "L89.621", description: "Pressure ulcer of left heel, stage 1" },
  { code: "L89.622", description: "Pressure ulcer of left heel, stage 2" },
  { code: "L89.623", description: "Pressure ulcer of left heel, stage 3" },
  { code: "L89.624", description: "Pressure ulcer of left heel, stage 4" },
  { code: "L89.629", description: "Pressure ulcer of left heel, unspecified stage" },
  { code: "L89.810", description: "Pressure ulcer of head, unstageable" },
  { code: "L89.811", description: "Pressure ulcer of head, stage 1" },
  { code: "L89.812", description: "Pressure ulcer of head, stage 2" },
  { code: "L89.813", description: "Pressure ulcer of head, stage 3" },
  { code: "L89.814", description: "Pressure ulcer of head, stage 4" },
  { code: "L89.819", description: "Pressure ulcer of head, unspecified stage" },
  { code: "L89.890", description: "Pressure ulcer of other site, unstageable" },
  { code: "L89.891", description: "Pressure ulcer of other site, stage 1" },
  { code: "L89.892", description: "Pressure ulcer of other site, stage 2" },
  { code: "L89.893", description: "Pressure ulcer of other site, stage 3" },
  { code: "L89.894", description: "Pressure ulcer of other site, stage 4" },
  { code: "L89.899", description: "Pressure ulcer of other site, unspecified stage" },
  { code: "L89.90", description: "Pressure ulcer of unspecified site, unspecified stage" },
  { code: "L89.91", description: "Pressure ulcer of unspecified site, stage 1" },
  { code: "L89.92", description: "Pressure ulcer of unspecified site, stage 2" },
  { code: "L89.93", description: "Pressure ulcer of unspecified site, stage 3" },
  { code: "L89.94", description: "Pressure ulcer of unspecified site, stage 4" },
  { code: "L89.95", description: "Pressure ulcer of unspecified site, unstageable" },
  { code: "T81.31A", description: "Disruption of extrenal operation (surgical) wound, not elsewhere classified, initial encounter" },
  { code: "T81.31XD", description: "Disruption of extrenal operation (surgical) wound, not elsewhere classified, subsequent encounter" },
  { code: "T81.31XS", description: "Disruption of extrenal operation (surgical) wound, not elsewhere classified, sequela" },
  { code: "T81.32XA", description: "Disruption of internal operation (surgical) wound, not elsewhere classified, initial encounter" },
  { code: "T81.32XD", description: "Disruption of internal operation (surgical) wound, not elsewhere classified, subsequent encounter" },
  { code: "T81.32XS", description: "Disruption of internal operation (surgical) wound, not elsewhere classified, sequela" },
  { code: "T81.33XA", description: "Disruption of traumatic injurybwound repair, initial encounter" },
  { code: "T81.33XD", description: "Disruption of traumatic injurybwound repair, subsequent encounter" },
  { code: "T81.33XS", description: "Disruption of traumatic injurybwound repair, sequela" }
];

// ============================================================================
// PROPACK CONFIGURATION OPTIONS (Updated from Excel Sheet)
// ============================================================================

// Primary Dressing Options
export const PROPACK_PRIMARY_OPTIONS = [
  { 
    value: 'collagen_powder', 
    label: 'Collagen Powder, 1g',
    code: 'A6010',
    requiresSize: false,
    description: 'Micronized collagen powder for deep wounds'
  },
  { 
    value: 'collagen_sheet', 
    label: 'Collagen Sheet',
    code: 'A6021/A6022/A6023',
    requiresSize: true,
    description: 'Collagen dressing sheet (size-dependent)'
  }
];

// Secondary Dressing Options - MILD EXUDATE
export const PROPACK_SECONDARY_MILD_EXUDATE = [
  { 
    value: 'hydrocolloid_border', 
    label: 'Hydrocolloid Dressing with Border',
    code: 'A6237/A6238',
    description: 'Self-adhesive hydrocolloid with border for mild drainage'
  },
  { 
    value: 'hydrocolloid_no_border', 
    label: 'Hydrocolloid Dressing without Border',
    code: 'A6236',
    description: 'Hydrocolloid dressing without adhesive border'
  },
  { 
    value: 'gauze_border', 
    label: 'Gauze Dressing with Border',
    code: 'A6219/A6220',
    description: 'Non-adherent gauze with adhesive border'
  },
  { 
    value: 'gauze_no_border', 
    label: 'Gauze Dressing without Border',
    code: 'A6224',
    description: 'Non-adherent gauze without border'
  }
];

// Secondary Dressing Options - MODERATE EXUDATE
export const PROPACK_SECONDARY_MODERATE_EXUDATE = [
  { 
    value: 'alginate', 
    label: 'Calcium Alginate Dressing',
    code: 'A6196/A6197',
    description: 'Highly absorbent alginate for moderate to heavy drainage'
  },
  { 
    value: 'absorbent', 
    label: 'Absorbent Dressing',
    code: 'A6253',
    description: 'Multi-layer absorbent dressing for moderate exudate'
  }
];

// Legacy combined secondary options (for backward compatibility)
export const PROPACK_SECONDARY_OPTIONS = [
  { value: 'collagen_dressing', label: 'Collagen Dressing' },
  { value: 'calcium_alginate', label: 'Calcium Alginate Dressing' },
  { value: 'xeroform_gauze', label: 'Xeroform Gauze Dressing' },
  { value: 'silicon_foam_border', label: 'Silicon Foam Dressing with Border' }
];

// Size Options (Updated with area specifications)
export const PROPACK_SIZE_OPTIONS = [
  { 
    value: 'small', 
    label: '2"*2" inch',
    maxArea: 16,
    displayLabel: 'Small'
  },
  { 
    value: 'medium', 
    label: '4"*4" inch',
    maxArea: 48,
    displayLabel: 'Medium'
  },
  { 
    value: 'large', 
    label: '7"*7" inch',
    maxArea: Infinity,
    displayLabel: 'Large'
  }
];

// Default Items Included with Every ProPack
export const PROPACK_DEFAULT_ITEMS = [
  'Conforming bandage (for securing)',
  'Waterproof tape',
  'Wound wash',
  'Disposable gloves'
];

// ============================================================================
// OPTIONAL ADD-ONS
// ============================================================================

// Securing Products (Optional)
export const PROPACK_SECURING_PRODUCTS = [
  { 
    value: 'conforming_bandage', 
    label: 'Conforming Bandage (≥3" <5")',
    code: 'A6446',
    description: 'Non-elastic sterile conforming bandage'
  },
  { 
    value: 'waterproof_tape', 
    label: 'Waterproof Tape',
    code: 'A4452',
    description: 'Water-resistant adhesive tape'
  }
];

// Compression Wrap System (For VLU Wounds)
export const PROPACK_COMPRESSION_WRAPS = [
  { 
    value: 'pad_band', 
    label: 'Padding Bandage (≥3" <5"/yd)',
    code: 'A6441',
    description: 'Padding bandage for compression therapy'
  },
  { 
    value: 'conform_band', 
    label: 'Conforming Bandage (≥3" <5"/yd)',
    code: 'A6446',
    description: 'Conforming bandage for compression'
  },
  { 
    value: 'mod_compression', 
    label: 'Moderate Compression Bandage (≥3" <5"/yd)',
    code: 'A6451',
    description: 'Moderate compression elastic bandage'
  },
  { 
    value: 'high_compression', 
    label: 'High Compression Bandage (≥3" <5"/yd)',
    code: 'A6452',
    description: 'High compression elastic bandage'
  },
  { 
    value: 'self_adhering', 
    label: 'Self-Adhering Bandage (≥3" <5"/yd)',
    code: 'A6454',
    description: 'Self-adherent compression wrap'
  }
];

// ============================================================================
// PRE-CONFIGURED PACKAGES (Based on Excel Sheet Pricing)
// ============================================================================

export const PROPACK_PRECONFIGURED_PACKAGES = {
  // MILD EXUDATE - COLLAGEN SHEET PACKAGES
  mild_sheet_small_30day: {
    id: 'mild_sheet_small_30day',
    name: 'Mild Exudate - Collagen Sheet (Small) - 30 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_sheet',
    primarySize: 'small',
    secondary: 'hydrocolloid_border',
    secondarySize: 'small',
    supply: '30-day',
    billable: 939.90,
    invoice: 469.95,
    reimbursement: 845.91,
    profit: 375.96
  },
  mild_sheet_small_12day: {
    id: 'mild_sheet_small_12day',
    name: 'Mild Exudate - Collagen Sheet (Small) - 12 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_sheet',
    primarySize: 'small',
    secondary: 'hydrocolloid_border',
    secondarySize: 'small',
    supply: '12-day',
    billable: 494.88,
    invoice: 247.44,
    reimbursement: 445.392,
    profit: 197.952
  },
  mild_sheet_medium_30day: {
    id: 'mild_sheet_medium_30day',
    name: 'Mild Exudate - Collagen Sheet (Medium) - 30 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_sheet',
    primarySize: 'medium',
    secondary: 'hydrocolloid_border',
    secondarySize: 'medium',
    supply: '30-day',
    billable: 993.30,
    invoice: 496.65,
    reimbursement: 893.97,
    profit: 397.32
  },
  mild_sheet_medium_12day: {
    id: 'mild_sheet_medium_12day',
    name: 'Mild Exudate - Collagen Sheet (Medium) - 12 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_sheet',
    primarySize: 'medium',
    secondary: 'hydrocolloid_border',
    secondarySize: 'medium',
    supply: '12-day',
    billable: 749.64,
    invoice: 374.82,
    reimbursement: 674.676,
    profit: 299.856
  },
  mild_sheet_large_30day: {
    id: 'mild_sheet_large_30day',
    name: 'Mild Exudate - Collagen Sheet (Large) - 30 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_sheet',
    primarySize: 'large',
    secondary: 'hydrocolloid_no_border',
    secondarySize: 'large',
    supply: '30-day',
    billable: 8361.15,
    invoice: 4180.575,
    reimbursement: 7525.035,
    profit: 3344.46
  },
  mild_sheet_large_12day: {
    id: 'mild_sheet_large_12day',
    name: 'Mild Exudate - Collagen Sheet (Large) - 12 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_sheet',
    primarySize: 'large',
    secondary: 'hydrocolloid_no_border',
    secondarySize: 'large',
    supply: '12-day',
    billable: 3748.86,
    invoice: 1874.43,
    reimbursement: 3373.974,
    profit: 1499.544
  },

  // MILD EXUDATE - COLLAGEN POWDER PACKAGES
  mild_powder_small_30day: {
    id: 'mild_powder_small_30day',
    name: 'Mild Exudate - Collagen Powder (Small) - 30 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'hydrocolloid_border',
    secondarySize: 'small',
    supply: '30-day',
    billable: 1365.00,
    invoice: 682.50,
    reimbursement: 1228.50,
    profit: 546.00
  },
  mild_powder_small_12day: {
    id: 'mild_powder_small_12day',
    name: 'Mild Exudate - Collagen Powder (Small) - 12 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'hydrocolloid_border',
    secondarySize: 'small',
    supply: '12-day',
    billable: 664.92,
    invoice: 332.46,
    reimbursement: 598.428,
    profit: 265.968
  },
  mild_powder_medium_30day: {
    id: 'mild_powder_medium_30day',
    name: 'Mild Exudate - Collagen Powder (Medium) - 30 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'hydrocolloid_border',
    secondarySize: 'medium',
    supply: '30-day',
    billable: 1418.40,
    invoice: 709.20,
    reimbursement: 1276.56,
    profit: 567.36
  },
  mild_powder_medium_12day: {
    id: 'mild_powder_medium_12day',
    name: 'Mild Exudate - Collagen Powder (Medium) - 12 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'hydrocolloid_border',
    secondarySize: 'medium',
    supply: '12-day',
    billable: 919.68,
    invoice: 459.84,
    reimbursement: 827.712,
    profit: 367.872
  },
  mild_powder_large_30day: {
    id: 'mild_powder_large_30day',
    name: 'Mild Exudate - Collagen Powder (Large) - 30 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'hydrocolloid_no_border',
    secondarySize: 'large',
    supply: '30-day',
    billable: 1548.75,
    invoice: 774.375,
    reimbursement: 1393.875,
    profit: 619.50
  },
  mild_powder_large_12day: {
    id: 'mild_powder_large_12day',
    name: 'Mild Exudate - Collagen Powder (Large) - 12 Day Supply',
    exudateLevel: 'mild',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'hydrocolloid_no_border',
    secondarySize: 'large',
    supply: '12-day',
    billable: 1023.90,
    invoice: 511.95,
    reimbursement: 921.51,
    profit: 409.56
  },

  // MODERATE EXUDATE - COLLAGEN SHEET PACKAGES
  moderate_sheet_small_30day: {
    id: 'moderate_sheet_small_30day',
    name: 'Moderate Exudate - Collagen Sheet (Small) - 30 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_sheet',
    primarySize: 'small',
    secondary: 'alginate',
    secondarySize: 'small',
    supply: '30-day',
    billable: 1253.25,
    invoice: 626.625,
    reimbursement: 1127.925,
    profit: 501.30
  },
  moderate_sheet_small_12day: {
    id: 'moderate_sheet_small_12day',
    name: 'Moderate Exudate - Collagen Sheet (Small) - 12 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_sheet',
    primarySize: 'small',
    secondary: 'alginate',
    secondarySize: 'small',
    supply: '12-day',
    billable: 485.52,
    invoice: 242.76,
    reimbursement: 436.968,
    profit: 194.208
  },
  moderate_sheet_medium_30day: {
    id: 'moderate_sheet_medium_30day',
    name: 'Moderate Exudate - Collagen Sheet (Medium) - 30 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_sheet',
    primarySize: 'medium',
    secondary: 'alginate',
    secondarySize: 'medium',
    supply: '30-day',
    billable: 1657.35,
    invoice: 828.675,
    reimbursement: 1491.615,
    profit: 662.94
  },
  moderate_sheet_medium_12day: {
    id: 'moderate_sheet_medium_12day',
    name: 'Moderate Exudate - Collagen Sheet (Medium) - 12 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_sheet',
    primarySize: 'medium',
    secondary: 'alginate',
    secondarySize: 'medium',
    supply: '12-day',
    billable: 640.92,
    invoice: 320.46,
    reimbursement: 576.828,
    profit: 256.368
  },
  moderate_sheet_large_30day: {
    id: 'moderate_sheet_large_30day',
    name: 'Moderate Exudate - Collagen Sheet (Large) - 30 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_sheet',
    primarySize: 'large',
    secondary: 'absorbent',
    secondarySize: 'large',
    supply: '30-day',
    billable: 8478.15,
    invoice: 4239.075,
    reimbursement: 7630.335,
    profit: 3391.26
  },
  moderate_sheet_large_12day: {
    id: 'moderate_sheet_large_12day',
    name: 'Moderate Exudate - Collagen Sheet (Large) - 12 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_sheet',
    primarySize: 'large',
    secondary: 'absorbent',
    secondarySize: 'large',
    supply: '12-day',
    billable: 3391.26,
    invoice: 1695.63,
    reimbursement: 3052.134,
    profit: 1356.504
  },

  // MODERATE EXUDATE - COLLAGEN POWDER PACKAGES
  moderate_powder_small_30day: {
    id: 'moderate_powder_small_30day',
    name: 'Moderate Exudate - Collagen Powder (Small) - 30 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'alginate',
    secondarySize: 'small',
    supply: '30-day',
    billable: 1678.35,
    invoice: 839.175,
    reimbursement: 1510.515,
    profit: 671.34
  },
  moderate_powder_small_12day: {
    id: 'moderate_powder_small_12day',
    name: 'Moderate Exudate - Collagen Powder (Small) - 12 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'alginate',
    secondarySize: 'small',
    supply: '12-day',
    billable: 655.56,
    invoice: 327.78,
    reimbursement: 590.004,
    profit: 262.224
  },
  moderate_powder_medium_30day: {
    id: 'moderate_powder_medium_30day',
    name: 'Moderate Exudate - Collagen Powder (Medium) - 30 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'alginate',
    secondarySize: 'medium',
    supply: '30-day',
    billable: 2082.45,
    invoice: 1041.225,
    reimbursement: 1874.205,
    profit: 832.98
  },
  moderate_powder_medium_12day: {
    id: 'moderate_powder_medium_12day',
    name: 'Moderate Exudate - Collagen Powder (Medium) - 12 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'alginate',
    secondarySize: 'medium',
    supply: '12-day',
    billable: 810.96,
    invoice: 405.48,
    reimbursement: 729.864,
    profit: 324.384
  },
  moderate_powder_large_30day: {
    id: 'moderate_powder_large_30day',
    name: 'Moderate Exudate - Collagen Powder (Large) - 30 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'absorbent',
    secondarySize: 'large',
    supply: '30-day',
    billable: 1665.75,
    invoice: 832.875,
    reimbursement: 1499.175,
    profit: 666.30
  },
  moderate_powder_large_12day: {
    id: 'moderate_powder_large_12day',
    name: 'Moderate Exudate - Collagen Powder (Large) - 12 Day Supply',
    exudateLevel: 'moderate',
    primary: 'collagen_powder',
    primarySize: null,
    secondary: 'absorbent',
    secondarySize: 'large',
    supply: '12-day',
    billable: 666.30,
    invoice: 333.15,
    reimbursement: 599.67,
    profit: 266.52
  }
};

// ============================================================================
// LEGACY DATA (Kept for backward compatibility)
// ============================================================================

// ProCare Kits (Legacy - keeping for existing functionality)
export const proCareKits = [
  {
    sku: 'EXU-ONE',
    name: 'ProCare EXU – Exudate Kit (One Size)',
    type: 'EXU',
    size: 'ONE',
    indication: 'Days 0–14, heavy drainage, any wound size. Exudate management.',
    contents: [
      'Advanced absorption dressings',
      'Exudate management materials',
      'Heavy drainage control supplies',
      'Wound assessment tools'
    ]
  },
  {
    sku: 'POW-S',
    name: 'ProCare POW – Small Powder Kit',
    type: 'POW',
    size: 'S',
    indication: 'Weeks 2–6, deep/small wounds (≤2×2 cm), tunnels/undermining.',
    contents: [
      'Small powder applicators',
      'Deep wound care supplies',
      'Tunnel/undermining treatment materials',
      'Measurement tools'
    ]
  },
  {
    sku: 'POW-M',
    name: 'ProCare POW – Medium Powder Kit',
    type: 'POW',
    size: 'M',
    indication: 'Weeks 2–6, moderate-depth wounds (~2×2–4×4 cm).',
    contents: [
      'Medium powder applicators',
      'Moderate wound care supplies',
      'Depth management materials',
      'Application guidance tools'
    ]
  },
  {
    sku: 'POW-L',
    name: 'ProCare POW – Large Powder Kit',
    type: 'POW',
    size: 'L',
    indication: 'Weeks 2–6, large deep wounds up to ~7×7–10×10 cm.',
    contents: [
      'Large powder applicators',
      'Extended coverage supplies',
      'Large wound management materials',
      'Professional application tools'
    ]
  },
  {
    sku: 'PAD-S',
    name: 'ProCare PAD – Small Pad Kit',
    type: 'PAD',
    size: 'S',
    indication: 'Weeks 2–6, shallow small wounds ≤2×2 cm.',
    contents: [
      'Small absorbent pads',
      'Shallow wound dressings',
      'Adhesive materials',
      'Protective barriers'
    ]
  },
  {
    sku: 'PAD-M',
    name: 'ProCare PAD – Medium Pad Kit',
    type: 'PAD',
    size: 'M',
    indication: 'Weeks 2–6, shallow mid-size wounds ~2×2–4×4 cm.',
    contents: [
      'Medium absorbent pads',
      'Standard dressing materials',
      'Secure adhesive systems',
      'Comfort padding'
    ]
  },
  {
    sku: 'PAD-L',
    name: 'ProCare PAD – Large Pad Kit',
    type: 'PAD',
    size: 'L',
    indication: 'Weeks 2–6, shallow wounds up to 7×7–10×10 cm.',
    contents: [
      'Large absorbent pads',
      'Extended coverage dressings',
      'Multi-layer protection',
      'Secure fixation materials'
    ]
  }
];

// ============================================================================
// ADVANCED CARE (GRAFT) OPTIONS
// ============================================================================

export const GRAFT_TYPE_OPTIONS = [
  { value: 'AmchoPlast', label: 'AmchoPlast' },
  { value: 'Actigraft', label: 'Actigraft' },
  { value: 'Xcell Amnio Matrix', label: 'Xcell Amnio Matrix' }
];

export const GRAFT_SIZE_OPTIONS = [
  { value: '2x2', label: '2"*2" inch' },
  { value: '4x4', label: '4"*4" inch' },
  { value: '7x7', label: '7"*7" inch' }
];

export const GRAFT_SIZE_OPTIONS_BY_TYPE = {
  'AmchoPlast': [
    { value: '14mm', label: '14mm' },
    { value: '18mm', label: '18mm' },
    { value: '1x1', label: '1x1' },
    { value: '2x2', label: '2x2' },
    { value: '2x3', label: '2x3' },
    { value: '2x4', label: '2x4' },
    { value: '2x6', label: '2x6' },
    { value: '3x3', label: '3x3' },
    { value: '4x4', label: '4x4' },
    { value: '4x6', label: '4x6' },
    { value: '4x8', label: '4x8' },
    { value: '6x8', label: '6x8' }
  ],
  'Actigraft': [
    // ✅ Add Actigraft sizes here if available
    { value: '2x2', label: '2x2' },
    { value: '4x4', label: '4x4' }
  ],
  'Xcell Amnio Matrix': [
    { value: '2x4', label: '2x4' },
    { value: '2x2', label: '2x2' }, // Assuming from image
    { value: '4x4', label: '4x4' }  // Assuming from image
  ]
};


// ============================================================================
// PROPACK SECONDARY OPTIONS MAPPING (Dynamic based on duration, exudate, primary size)
// ============================================================================

export const PROPACK_SECONDARY_OPTIONS_MAPPING = {
  '12-day': {
    'Mild': {
      'small': [
        {
          value: 'hydrocolloid_border_4x4',
          label: 'Hydrocolloid w/ Border - 4"x4" (103cm²), Pad: 2"x2" (26cm²)',
          productSize: '4"x4" (103cm²)',
          padSize: '2"x2" (26cm²)'
        }
      ],
      'medium': [
        {
          value: 'hydrocolloid_border_6x6',
          label: 'Hydrocolloid w/ Border - 6"x6" (232cm²), Pad: 5"x4.25" (169cm²)',
          productSize: '6"x6" (232cm²)',
          padSize: '5"x4.25" (169cm²)'
        }
      ],
      'large': [
        {
          value: 'hydrocolloid_no_border_8x8',
          label: 'Hydrocolloid w/o Border - 8"x8" (413cm²), Non-Adhesive',
          productSize: '8"x8" (413cm²)',
          padSize: 'N/A: Non-Adhesive'
        }
      ]
    },
    'Moderate': {
      'small': [
        {
          value: 'silicone_adhesive_border_4x4',
          label: 'Silicone Adhesive w/ Border - 4"x4" (103cm²), Pad: 2"x2" (26cm²)',
          productSize: '4"x4" (103cm²)',
          padSize: '2"x2" (26cm²)'
        }
      ],
      'medium': [
        {
          value: 'silicone_adhesive_border_7x7',
          label: 'Silicone Adhesive w/ Border - 7"x7" (316cm²), Pad: 4.5"x4.5" (131cm²)',
          productSize: '7"x7" (316cm²)',
          padSize: '4.5"x4.5" (131cm²)'
        }
      ],
      'large': [
        {
          value: 'abd_pad_7.5x8',
          label: 'ABD Pad - 7.5"x8" (387cm²), Non-Adhesive',
          productSize: '7.5"x8" (387cm²)',
          padSize: 'N/A: Non-Adhesive'
        }
      ]
    }
  },
  '30-day': {
    'Mild': {
      'small': [
        {
          value: 'island_dressing_border_4x4',
          label: 'Island Dressing w/ Border - 4"x4" (103cm²), Pad: 2"x2" (26cm²)',
          productSize: '4"x4" (103cm²)',
          padSize: '2"x2" (26cm²)'
        }
      ],
      'medium': [
        {
          value: 'island_dressing_border_6x6',
          label: 'Island Dressing w/ Border - 6"x6" (232cm²), Pad: 4.3"x4.3" (119cm²)',
          productSize: '6"x6" (232cm²)',
          padSize: '4.3"x4.3" (119cm²)'
        }
      ],
      'large': [
        {
          value: 'abd_pad_7.5x8_mild',
          label: 'ABD Pad - 7.5"x8" (387cm²), Non-Adhesive',
          productSize: '7.5"x8" (387cm²)',
          padSize: 'N/A: Non-Adhesive'
        }
      ]
    },
    'Moderate': {
      'small': [
        {
          value: 'silicone_adhesive_border_4x4_mod',
          label: 'Silicone Adhesive w/ Border - 4"x4" (103cm²), Pad: 2"x2" (26cm²)',
          productSize: '4"x4" (103cm²)',
          padSize: '2"x2" (26cm²)'
        }
      ],
      'medium': [
        {
          value: 'silicone_adhesive_border_7x7_mod',
          label: 'Silicone Adhesive w/ Border - 7"x7" (316cm²), Pad: 4.5"x4.5" (131cm²)',
          productSize: '7"x7" (316cm²)',
          padSize: '4.5"x4.5" (131cm²)'
        }
      ],
      'large': [
        {
          value: 'abd_pad_7.5x8_mod',
          label: 'ABD Pad - 7.5"x8" (387cm²), Non-Adhesive',
          productSize: '7.5"x8" (387cm²)',
          padSize: 'N/A: Non-Adhesive'
        }
      ]
    }
  }
};




// ============================================================================
// PROPACKS IVR FORM - PDF GRID MAPPING
// Maps each checkbox option from the PDF to complete kit configuration
// ============================================================================

// export const PROPACKS_IVR_GRID_OPTIONS = {
//   // ===== SMALL / MILD / COLLAGEN SHEET =====
//   'small_mild_sheet_30day': {
//     id: 'small_mild_sheet_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'SMALL / MILD / COLLAGEN SHEET',
//     size: 'small',
//     drainage: 'Mild',
//     primaryType: 'collagen_sheet',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6021', 'A6219'],
//     products: [
//       { code: 'A6021', units: 30, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6219', units: 30, description: 'Island Dressing 4"x4" (2"x2" pad)' }
//     ],
//     // Mapped to existing structure
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',  // small
//     proPackSecondary: 'Island Dressing 4"x4" (2"x2" pad)',
//     // proPackSecondarySize: '4x4',
//     kitDuration: '30-day'
//   },
  
//   'small_mild_sheet_12day': {
//     id: 'small_mild_sheet_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'SMALL / MILD / COLLAGEN SHEET',
//     size: 'small',
//     drainage: 'Mild',
//     primaryType: 'collagen_sheet',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6021', 'A6237'],
//     products: [
//       { code: 'A6021', units: 12, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6237', units: 12, description: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',
//     proPackSecondary: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)',
//     // proPackSecondarySize: '4x4',
//     kitDuration: '12-day'
//   },

//   // ===== SMALL / MILD / COLLAGEN POWDER =====
//   'small_mild_powder_30day': {
//     id: 'small_mild_powder_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'SMALL / MILD / COLLAGEN POWDER',
//     size: 'small',
//     drainage: 'Mild',
//     primaryType: 'collagen_powder',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6010', 'A6219'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6219', units: 30, description: 'Island Dressing 4"x4" (2"x2" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Island Dressing 4"x4" (2"x2" pad)',
//     // proPackSecondarySize: '4x4',
//     kitDuration: '30-day'
//   },

//   'small_mild_powder_12day': {
//     id: 'small_mild_powder_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'SMALL / MILD / COLLAGEN POWDER',
//     size: 'small',
//     drainage: 'Mild',
//     primaryType: 'collagen_powder',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6010', 'A6237'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6237', units: 12, description: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)',
//     // proPackSecondarySize: '4x4',
//     kitDuration: '12-day'
//   },

//   // ===== MEDIUM / MILD / COLLAGEN SHEET =====
//   'medium_mild_sheet_30day': {
//     id: 'medium_mild_sheet_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'MEDIUM / MILD / COLLAGEN SHEET',
//     size: 'medium',
//     drainage: 'Mild',
//     primaryType: 'collagen_sheet',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6021', 'A6220'],
//     products: [
//       { code: 'A6021', units: 30, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6220', units: 30, description: 'Island Dressing 6"x6" (4.3"x4.3" pad)' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',  // small
//     proPackSecondary: 'Island Dressing 6"x6" (4.3"x4.3" pad)',
//     // proPackSecondarySize: '6x6',
//     kitDuration: '30-day'
//   },

//   'medium_mild_sheet_12day': {
//     id: 'medium_mild_sheet_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'MEDIUM / MILD / COLLAGEN SHEET',
//     size: 'medium',
//     drainage: 'Mild',
//     primaryType: 'collagen_sheet',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6021', 'A6238'],
//     products: [
//       { code: 'A6021', units: 12, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6238', units: 12, description: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',
//     proPackSecondary: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)',
//     // proPackSecondarySize: '6x6',
//     kitDuration: '12-day'
//   },

//   // ===== MEDIUM / MILD / COLLAGEN POWDER =====
//   'medium_mild_powder_30day': {
//     id: 'medium_mild_powder_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'MEDIUM / MILD / COLLAGEN POWDER',
//     size: 'medium',
//     drainage: 'Mild',
//     primaryType: 'collagen_powder',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6010', 'A6220'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6220', units: 30, description: 'Island Dressing 6"x6" (4.3"x4.3" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Island Dressing 6"x6" (4.3"x4.3" pad)',
//     // proPackSecondarySize: '6x6',
//     kitDuration: '30-day'
//   },

//   'medium_mild_powder_12day': {
//     id: 'medium_mild_powder_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'MEDIUM / MILD / COLLAGEN POWDER',
//     size: 'medium',
//     drainage: 'Mild',
//     primaryType: 'collagen_powder',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6010', 'A6238'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6238', units: 12, description: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)',
//     // proPackSecondarySize: '6x6',
//     kitDuration: '12-day'
//   },

//   // ===== LARGE / MILD / COLLAGEN SHEET =====
//   'large_mild_sheet_30day': {
//     id: 'large_mild_sheet_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'LARGE / MILD / COLLAGEN SHEET',
//     size: 'large',
//     drainage: 'Mild',
//     primaryType: 'collagen_sheet',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6023', 'A6253'],
//     products: [
//       { code: 'A6023', units: 30, description: 'Collagen Sheet >48 sq in (7"x7")' },
//       { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '7"x7"',  // large
//     defaultItems: 'large_sheet_30day',
//     proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
//     //proPackSecondarySize: '7.5x8',
//     kitDuration: '30-day'
//   },

//   'large_mild_sheet_12day': {
//     id: 'large_mild_sheet_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'LARGE / MILD / COLLAGEN SHEET',
//     size: 'large',
//     drainage: 'Mild',
//     primaryType: 'collagen_sheet',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6023', 'A6236'],
//     products: [
//       { code: 'A6023', units: 12, description: 'Collagen Sheet >48 sq in (7"x7")' },
//       { code: 'A6236', units: 12, description: 'Hydrocolloid w/o Border 8"x8"' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '7"x7"',  // large
//     defaultItems: 'large_sheet_12day',
//     proPackSecondary: 'Hydrocolloid w/o Border 8"x8"',
//     // proPackSecondarySize: '8x8',
//     kitDuration: '12-day'
//   },

//   // ===== LARGE / MILD / COLLAGEN POWDER =====
//   'large_mild_powder_30day': {
//     id: 'large_mild_powder_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'LARGE / MILD / COLLAGEN POWDER',
//     size: 'large',
//     drainage: 'Mild',
//     primaryType: 'collagen_powder',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6010', 'A6253'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     defaultItems: 'large_powder_30day',
//     proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
//     // proPackSecondarySize: '7.5x8',
//     kitDuration: '30-day'
//   },

//   'large_mild_powder_12day': {
//     id: 'large_mild_powder_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'LARGE / MILD / COLLAGEN POWDER',
//     size: 'large',
//     drainage: 'Mild',
//     primaryType: 'collagen_powder',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6010', 'A6236'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6236', units: 12, description: 'Hydrocolloid w/o Border 8"x8"' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     defaultItems: 'large_powder_12day',
//     proPackSecondary: 'Hydrocolloid w/o Border 8"x8"',
//     // proPackSecondarySize: '8x8',
//     kitDuration: '12-day'
//   },

//   // ===== SMALL / MODERATE / COLLAGEN SHEET =====
//   'small_moderate_sheet_30day': {
//     id: 'small_moderate_sheet_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'SMALL / MODERATE / COLLAGEN SHEET',
//     size: 'small',
//     drainage: 'Moderate',
//     primaryType: 'collagen_sheet',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6021', 'A6197'],
//     products: [
//       { code: 'A6021', units: 30, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',
//     proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
//     // proPackSecondarySize: '4x4',
//     kitDuration: '30-day'
//   },

//   'small_moderate_sheet_12day': {
//     id: 'small_moderate_sheet_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'SMALL / MODERATE / COLLAGEN SHEET',
//     size: 'small',
//     drainage: 'Moderate',
//     primaryType: 'collagen_sheet',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6021', 'A6196'],
//     products: [
//       { code: 'A6021', units: 12, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6196', units: 12, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',
//     proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
//     // proPackSecondarySize: '4x4',
//     kitDuration: '12-day'
//   },

//   // ===== SMALL / MODERATE / COLLAGEN POWDER =====
//   'small_moderate_powder_30day': {
//     id: 'small_moderate_powder_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'SMALL / MODERATE / COLLAGEN POWDER',
//     size: 'small',
//     drainage: 'Moderate',
//     primaryType: 'collagen_powder',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6010', 'A6197'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
//     // proPackSecondarySize: '4x4',
//     kitDuration: '30-day'
//   },

//   'small_moderate_powder_12day': {
//     id: 'small_moderate_powder_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'SMALL / MODERATE / COLLAGEN POWDER',
//     size: 'small',
//     drainage: 'Moderate',
//     primaryType: 'collagen_powder',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6010', 'A6196'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6196', units: 12, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
//     //proPackSecondarySize: '4x4',
//     kitDuration: '12-day'
//   },

//   // ===== MEDIUM / MODERATE / COLLAGEN SHEET =====
//   'medium_moderate_sheet_30day': {
//     id: 'medium_moderate_sheet_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'MEDIUM / MODERATE / COLLAGEN SHEET',
//     size: 'medium',
//     drainage: 'Moderate',
//     primaryType: 'collagen_sheet',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6021', 'A6197'],
//     products: [
//       { code: 'A6021', units: 30, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',
//     proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
//     // proPackSecondarySize: '7x7',
//     kitDuration: '30-day'
//   },

//   'medium_moderate_sheet_12day': {
//     id: 'medium_moderate_sheet_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'MEDIUM / MODERATE / COLLAGEN SHEET',
//     size: 'medium',
//     drainage: 'Moderate',
//     primaryType: 'collagen_sheet',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6021', 'A6197'],
//     products: [
//       { code: 'A6021', units: 12, description: 'Collagen Sheet ≤16 sq in (2"x2")' },
//       { code: 'A6197', units: 12, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '2"x2"',
//     proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
//     // proPackSecondarySize: '7x7',
//     kitDuration: '12-day'
//   },

//   // ===== MEDIUM / MODERATE / COLLAGEN POWDER =====
//   'medium_moderate_powder_30day': {
//     id: 'medium_moderate_powder_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'MEDIUM / MODERATE / COLLAGEN POWDER',
//     size: 'medium',
//     drainage: 'Moderate',
//     primaryType: 'collagen_powder',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6010', 'A6197'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
//     // proPackSecondarySize: '7x7',
//     kitDuration: '30-day'
//   },

//   'medium_moderate_powder_12day': {
//     id: 'medium_moderate_powder_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'MEDIUM / MODERATE / COLLAGEN POWDER',
//     size: 'medium',
//     drainage: 'Moderate',
//     primaryType: 'collagen_powder',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6010', 'A6197'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6197', units: 12, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
//     // proPackSecondarySize: '7x7',
//     kitDuration: '12-day'
//   },

//   // ===== LARGE / MODERATE / COLLAGEN SHEET =====
//   'large_moderate_sheet_30day': {
//     id: 'large_moderate_sheet_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'LARGE / MODERATE / COLLAGEN SHEET',
//     size: 'large',
//     drainage: 'Moderate',
//     primaryType: 'collagen_sheet',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6023', 'A6253'],
//     products: [
//       { code: 'A6023', units: 30, description: 'Collagen Sheet >48 sq in (7"x7")' },
//       { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '7"x7"',
//     proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
//     // proPackSecondarySize: '7x7',
//     defaultItems: 'large_sheet_30day',
//     kitDuration: '30-day'
//   },

//   'large_moderate_sheet_12day': {
//     id: 'large_moderate_sheet_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'LARGE / MODERATE / COLLAGEN SHEET',
//     size: 'large',
//     drainage: 'Moderate',
//     primaryType: 'collagen_sheet',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6023', 'A6446'],
//     products: [
//       { code: 'A6023', units: 12, description: 'Collagen Sheet >48 sq in (7"x7")' },
//       { code: 'A6253', units: 12, description: 'ABD Pad 7.5"x8" w/o Border' },
//     ],
//     proPackPrimary: 'collagen_sheet',
//     proPackPrimarySize: '7"x7"',
//     proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
//     // proPackSecondarySize: '7x7',
//     defaultItems: 'large_sheet_12day',
//     kitDuration: '12-day'
//   },

//   // ===== LARGE / MODERATE / COLLAGEN POWDER =====
//   'large_moderate_powder_30day': {
//     id: 'large_moderate_powder_30day',
//     displayName: '(30-Day) Daily Dressing Changes',
//     category: 'LARGE / MODERATE / COLLAGEN POWDER',
//     size: 'large',
//     drainage: 'Moderate',
//     primaryType: 'collagen_powder',
//     frequency: 'daily',
//     duration: '30-day',
//     productCodes: ['A6010', 'A6253'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
//     // proPackSecondarySize: '7.5x8',
//     defaultItems: 'large_powder_30day',
//     kitDuration: '30-day'
//   },

//   'large_moderate_powder_12day': {
//     id: 'large_moderate_powder_12day',
//     displayName: '(12-Day) 3 Dressing Changes Per Week',
//     category: 'LARGE / MODERATE / COLLAGEN POWDER',
//     size: 'large',
//     drainage: 'Moderate',
//     primaryType: 'collagen_powder',
//     frequency: 'weekly',
//     duration: '12-day',
//     productCodes: ['A6010', 'A6446', 'A4452'],
//     products: [
//       { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
//       { code: 'A6253', units: 12, description: 'ABD Pad 7.5"x8" w/o Border' },
//     ],
//     proPackPrimary: 'collagen_powder',
//     proPackPrimarySize: null,
//     proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
//     // proPackSecondarySize: '7.5x8',
//     defaultItems: 'large_powder_12day',
//     kitDuration: '12-day'
//   },
// };

// export const PROPACKS_SIZE_DEFAULT_ITEMS = {
//   'small': [],
//   'medium': [],
//   'large': {
//     // Different units for different combinations
//     'sheet_30day': [
//       { code: 'A6446', units: 15, description: 'Conforming Bandage' },
//       { code: 'A4452', units: 120, description: 'Waterproof Tape' }
//     ],
//     'sheet_12day': [
//       { code: 'A6446', units: 6, description: 'Conforming Bandage' },
//       { code: 'A4452', units: 48, description: 'Waterproof Tape' }
//     ],
//     'powder_30day': [
//       { code: 'A6446', units: 15, description: 'Conforming Bandage' },
//       { code: 'A4452', units: 120, description: 'Waterproof Tape' }
//     ],
//     'powder_12day': [
//       { code: 'A6446', units: 6, description: 'Conforming Bandage' },
//       { code: 'A4452', units: 48, description: 'Waterproof Tape' }
//     ]
//   }
// };

// Helper function to get complete product list with default items
export const getCompleteProductList = (optionId) => {
  const option = PROPACKS_IVR_GRID_OPTIONS[optionId];
  if (!option) return null;

  let allProducts = [...option.products];

  // Add default items if applicable
  if (option.defaultItems) {
    const sizeDefaults = PROPACKS_SIZE_DEFAULT_ITEMS.large?.[option.defaultItems];
    if (sizeDefaults) {
      allProducts = [...allProducts, ...sizeDefaults];
    }
  }

  return {
    ...option,
    products: allProducts
  };
};

// ============================================================================
// CHANGES NEEDED IN conservativeCareData.js
// ============================================================================
//
// CHANGE 1: In PROPACKS_SIZE_DEFAULT_ITEMS, add '15day' entries inside 'large':
// ============================================================================

// Find this block in PROPACKS_SIZE_DEFAULT_ITEMS.large and ADD the two new entries:
export const PROPACKS_SIZE_DEFAULT_ITEMS = {
  'small': [],
  'medium': [],
  'large': {
    // --- EXISTING ---
    'sheet_30day': [
      { code: 'A6446', units: 15, description: 'Conforming Bandage' },
      { code: 'A4452', units: 120, description: 'Waterproof Tape' }
    ],
    'sheet_12day': [
      { code: 'A6446', units: 6, description: 'Conforming Bandage' },
      { code: 'A4452', units: 48, description: 'Waterproof Tape' }
    ],
    'powder_30day': [
      { code: 'A6446', units: 15, description: 'Conforming Bandage' },
      { code: 'A4452', units: 120, description: 'Waterproof Tape' }
    ],
    'powder_12day': [
      { code: 'A6446', units: 6, description: 'Conforming Bandage' },
      { code: 'A4452', units: 48, description: 'Waterproof Tape' }
    ],
    // --- ADD THESE TWO NEW ENTRIES ---
    'large_sheet_15day': [
      { code: 'A6446', units: 8, description: 'Conforming Bandage' },
      { code: 'A4452', units: 60, description: 'Waterproof Tape' }
    ],
    'large_powder_15day': [
      { code: 'A6446', units: 8, description: 'Conforming Bandage' },
      { code: 'A4452', units: 60, description: 'Waterproof Tape' }
    ],
  }
};

// ============================================================================
// CHANGE 2: In PROPACKS_IVR_GRID_OPTIONS, insert the 12 new 15-day entries.
//
// INSERT each 15-day entry BETWEEN the corresponding _30day and _12day entries
// so the display order within each category is: 30-day | 15-day | 12-day
// (The 3-column grid in the modal maps naturally — one row per category.)
// ============================================================================

// Below is the FULL updated PROPACKS_IVR_GRID_OPTIONS showing the 15-day
// entries in the correct positions. Replace the entire object.

export const PROPACKS_IVR_GRID_OPTIONS = {

  // ===== SMALL / MILD / COLLAGEN SHEET =====
  'small_mild_sheet_30day': {
    id: 'small_mild_sheet_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'SMALL / MILD / COLLAGEN SHEET',
    size: 'small',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6021', 'A6219'],
    products: [
      { code: 'A6021', units: 30, description: 'Collagen Sheet ≤4 sq in (2"x2")' },
      { code: 'A6219', units: 30, description: 'Island Dressing 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '2"x2"',
    proPackSecondary: 'Island Dressing 4"x4" (2"x2" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'small_mild_sheet_15day': {
    id: 'small_mild_sheet_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'SMALL / MILD / COLLAGEN SHEET',
    size: 'small',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6021', 'A6219'],
    products: [
      { code: 'A6021', units: 15, description: 'Collagen Sheet ≤4 sq in (2"x2")' },
      { code: 'A6219', units: 15, description: 'Island Dressing 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '2"x2"',
    proPackSecondary: 'Island Dressing 4"x4" (2"x2" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'small_mild_sheet_12day': {
    id: 'small_mild_sheet_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'SMALL / MILD / COLLAGEN SHEET',
    size: 'small',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6021', 'A6237'],
    products: [
      { code: 'A6021', units: 12, description: 'Collagen Sheet ≤4 sq in (2"x2")' },
      { code: 'A6237', units: 12, description: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '2"x2"',
    proPackSecondary: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)',
    kitDuration: '12-day'
  },

  // ===== SMALL / MILD / COLLAGEN POWDER =====
  'small_mild_powder_30day': {
    id: 'small_mild_powder_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'SMALL / MILD / COLLAGEN POWDER',
    size: 'small',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6010', 'A6219'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6219', units: 30, description: 'Island Dressing 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Island Dressing 4"x4" (2"x2" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'small_mild_powder_15day': {
    id: 'small_mild_powder_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'SMALL / MILD / COLLAGEN POWDER',
    size: 'small',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6010', 'A6219'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6219', units: 15, description: 'Island Dressing 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Island Dressing 4"x4" (2"x2" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'small_mild_powder_12day': {
    id: 'small_mild_powder_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'SMALL / MILD / COLLAGEN POWDER',
    size: 'small',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6010', 'A6237'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6237', units: 12, description: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Hydrocolloid w/ Border 4"x4" (2"x2" pad)',
    kitDuration: '12-day'
  },

  // ===== MEDIUM / MILD / COLLAGEN SHEET =====
  'medium_mild_sheet_30day': {
    id: 'medium_mild_sheet_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'MEDIUM / MILD / COLLAGEN SHEET',
    size: 'medium',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6021', 'A6220'],
    products: [
      { code: 'A6021', units: 30, description: 'Collagen Sheet ≤16 sq in (4"x4")' },
      { code: 'A6220', units: 30, description: 'Island Dressing 6"x6" (4.3"x4.3" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '4"x4"',
    proPackSecondary: 'Island Dressing 6"x6" (4.3"x4.3" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'medium_mild_sheet_15day': {
    id: 'medium_mild_sheet_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'MEDIUM / MILD / COLLAGEN SHEET',
    size: 'medium',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6021', 'A6220'],
    products: [
      { code: 'A6021', units: 15, description: 'Collagen Sheet ≤16 sq in (4"x4")' },
      { code: 'A6220', units: 15, description: 'Island Dressing 6"x6" (4.3"x4.3" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '4"x4"',
    proPackSecondary: 'Island Dressing 6"x6" (4.3"x4.3" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'medium_mild_sheet_12day': {
    id: 'medium_mild_sheet_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'MEDIUM / MILD / COLLAGEN SHEET',
    size: 'medium',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6021', 'A6238'],
    products: [
      { code: 'A6021', units: 12, description: 'Collagen Sheet ≤16 sq in (4"x4")' },
      { code: 'A6238', units: 12, description: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '4"x4"',
    proPackSecondary: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)',
    kitDuration: '12-day'
  },

  // ===== MEDIUM / MILD / COLLAGEN POWDER =====
  'medium_mild_powder_30day': {
    id: 'medium_mild_powder_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'MEDIUM / MILD / COLLAGEN POWDER',
    size: 'medium',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6010', 'A6220'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6220', units: 30, description: 'Island Dressing 6"x6" (4.3"x4.3" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Island Dressing 6"x6" (4.3"x4.3" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'medium_mild_powder_15day': {
    id: 'medium_mild_powder_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'MEDIUM / MILD / COLLAGEN POWDER',
    size: 'medium',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6010', 'A6220'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6220', units: 15, description: 'Island Dressing 6"x6" (4.3"x4.3" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Island Dressing 6"x6" (4.3"x4.3" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'medium_mild_powder_12day': {
    id: 'medium_mild_powder_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'MEDIUM / MILD / COLLAGEN POWDER',
    size: 'medium',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6010', 'A6238'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6238', units: 12, description: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Hydrocolloid w/ Border 6"x6" (5"x4.25" pad)',
    kitDuration: '12-day'
  },

  // ===== LARGE / MILD / COLLAGEN SHEET =====
  'large_mild_sheet_30day': {
    id: 'large_mild_sheet_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'LARGE / MILD / COLLAGEN SHEET',
    size: 'large',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6023', 'A6253'],
    products: [
      { code: 'A6023', units: 30, description: 'Collagen Sheet >48 sq in (7"x7")' },
      { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '7"x7"',
    defaultItems: 'large_sheet_30day',
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'large_mild_sheet_15day': {
    id: 'large_mild_sheet_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'LARGE / MILD / COLLAGEN SHEET',
    size: 'large',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6023', 'A6253'],
    products: [
      { code: 'A6023', units: 15, description: 'Collagen Sheet >48 sq in (7"x7")' },
      { code: 'A6253', units: 15, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '7"x7"',
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    defaultItems: 'large_sheet_15day',
    kitDuration: '15-day'
  },

  'large_mild_sheet_12day': {
    id: 'large_mild_sheet_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'LARGE / MILD / COLLAGEN SHEET',
    size: 'large',
    drainage: 'Mild',
    primaryType: 'collagen_sheet',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6023', 'A6236'],
    products: [
      { code: 'A6023', units: 12, description: 'Collagen Sheet >48 sq in (7"x7")' },
      { code: 'A6236', units: 12, description: 'Hydrocolloid w/o Border 8"x8"' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '7"x7"',
    defaultItems: 'large_sheet_12day',
    proPackSecondary: 'Hydrocolloid w/o Border 8"x8"',
    kitDuration: '12-day'
  },

  // ===== LARGE / MILD / COLLAGEN POWDER =====
  'large_mild_powder_30day': {
    id: 'large_mild_powder_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'LARGE / MILD / COLLAGEN POWDER',
    size: 'large',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6010', 'A6253'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    defaultItems: 'large_powder_30day',
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'large_mild_powder_15day': {
    id: 'large_mild_powder_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'LARGE / MILD / COLLAGEN POWDER',
    size: 'large',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6010', 'A6253'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6253', units: 15, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    defaultItems: 'large_powder_15day',
    kitDuration: '15-day'
  },

  'large_mild_powder_12day': {
    id: 'large_mild_powder_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'LARGE / MILD / COLLAGEN POWDER',
    size: 'large',
    drainage: 'Mild',
    primaryType: 'collagen_powder',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6010', 'A6236'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6236', units: 12, description: 'Hydrocolloid w/o Border 8"x8"' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    defaultItems: 'large_powder_12day',
    proPackSecondary: 'Hydrocolloid w/o Border 8"x8"',
    kitDuration: '12-day'
  },

  // ===== SMALL / MODERATE / COLLAGEN SHEET =====
  'small_moderate_sheet_30day': {
    id: 'small_moderate_sheet_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'SMALL / MODERATE / COLLAGEN SHEET',
    size: 'small',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6021', 'A6197'],
    products: [
      { code: 'A6021', units: 30, description: 'Collagen Sheet ≤4 sq in (2"x2")' },
      { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '2"x2"',
    proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'small_moderate_sheet_15day': {
    id: 'small_moderate_sheet_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'SMALL / MODERATE / COLLAGEN SHEET',
    size: 'small',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6021', 'A6197'],
    products: [
      { code: 'A6021', units: 15, description: 'Collagen Sheet ≤4 sq in (2"x2")' },
      { code: 'A6197', units: 15, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '2"x2"',
    proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'small_moderate_sheet_12day': {
    id: 'small_moderate_sheet_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'SMALL / MODERATE / COLLAGEN SHEET',
    size: 'small',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6021', 'A6196'],
    products: [
      { code: 'A6021', units: 12, description: 'Collagen Sheet ≤4 sq in (2"x2")' },
      { code: 'A6196', units: 12, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '2"x2"',
    proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
    kitDuration: '12-day'
  },

  // ===== SMALL / MODERATE / COLLAGEN POWDER =====
  'small_moderate_powder_30day': {
    id: 'small_moderate_powder_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'SMALL / MODERATE / COLLAGEN POWDER',
    size: 'small',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6010', 'A6197'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'small_moderate_powder_15day': {
    id: 'small_moderate_powder_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'SMALL / MODERATE / COLLAGEN POWDER',
    size: 'small',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6010', 'A6197'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6197', units: 15, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'small_moderate_powder_12day': {
    id: 'small_moderate_powder_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'SMALL / MODERATE / COLLAGEN POWDER',
    size: 'small',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6010', 'A6196'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6196', units: 12, description: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Silicone Dressing w/ Border 4"x4" (2"x2" pad)',
    kitDuration: '12-day'
  },

  // ===== MEDIUM / MODERATE / COLLAGEN SHEET =====
  'medium_moderate_sheet_30day': {
    id: 'medium_moderate_sheet_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'MEDIUM / MODERATE / COLLAGEN SHEET',
    size: 'medium',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6021', 'A6197'],
    products: [
      { code: 'A6021', units: 30, description: 'Collagen Sheet ≤16 sq in (4"x4")' },
      { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '4"x4"',
    proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'medium_moderate_sheet_15day': {
    id: 'medium_moderate_sheet_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'MEDIUM / MODERATE / COLLAGEN SHEET',
    size: 'medium',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6021', 'A6197'],
    products: [
      { code: 'A6021', units: 15, description: 'Collagen Sheet ≤16 sq in (4"x4")' },
      { code: 'A6197', units: 15, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '4"x4"',
    proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'medium_moderate_sheet_12day': {
    id: 'medium_moderate_sheet_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'MEDIUM / MODERATE / COLLAGEN SHEET',
    size: 'medium',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6021', 'A6197'],
    products: [
      { code: 'A6021', units: 12, description: 'Collagen Sheet ≤16 sq in (4"x4")' },
      { code: 'A6197', units: 12, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '4"x4"',
    proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
    kitDuration: '12-day'
  },

  // ===== MEDIUM / MODERATE / COLLAGEN POWDER =====
  'medium_moderate_powder_30day': {
    id: 'medium_moderate_powder_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'MEDIUM / MODERATE / COLLAGEN POWDER',
    size: 'medium',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6010', 'A6197'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6197', units: 30, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'medium_moderate_powder_15day': {
    id: 'medium_moderate_powder_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'MEDIUM / MODERATE / COLLAGEN POWDER',
    size: 'medium',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6010', 'A6197'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6197', units: 15, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
    defaultItems: null,
    kitDuration: '15-day'
  },

  'medium_moderate_powder_12day': {
    id: 'medium_moderate_powder_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'MEDIUM / MODERATE / COLLAGEN POWDER',
    size: 'medium',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6010', 'A6197'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6197', units: 12, description: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
    kitDuration: '12-day'
  },

  // ===== LARGE / MODERATE / COLLAGEN SHEET =====
  'large_moderate_sheet_30day': {
    id: 'large_moderate_sheet_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'LARGE / MODERATE / COLLAGEN SHEET',
    size: 'large',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6023', 'A6253'],
    products: [
      { code: 'A6023', units: 30, description: 'Collagen Sheet >48 sq in (7"x7")' },
      { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '7"x7"',
    proPackSecondary: 'Silicone Dressing w/ Border 7"x7" (4.5"x4.5" pad)',
    defaultItems: 'large_sheet_30day',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'large_moderate_sheet_15day': {
    id: 'large_moderate_sheet_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'LARGE / MODERATE / COLLAGEN SHEET',
    size: 'large',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6023', 'A6253'],
    products: [
      { code: 'A6023', units: 15, description: 'Collagen Sheet >48 sq in (7"x7")' },
      { code: 'A6253', units: 15, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '7"x7"',
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    defaultItems: 'large_sheet_15day',
    kitDuration: '15-day'
  },

  'large_moderate_sheet_12day': {
    id: 'large_moderate_sheet_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'LARGE / MODERATE / COLLAGEN SHEET',
    size: 'large',
    drainage: 'Moderate',
    primaryType: 'collagen_sheet',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6023', 'A6446'],
    products: [
      { code: 'A6023', units: 12, description: 'Collagen Sheet >48 sq in (7"x7")' },
      { code: 'A6253', units: 12, description: 'ABD Pad 7.5"x8" w/o Border' },
    ],
    proPackPrimary: 'collagen_sheet',
    proPackPrimarySize: '7"x7"',
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    defaultItems: 'large_sheet_12day',
    kitDuration: '12-day'
  },

  // ===== LARGE / MODERATE / COLLAGEN POWDER =====
  'large_moderate_powder_30day': {
    id: 'large_moderate_powder_30day',
    displayName: '(30-Day) Daily Dressing Changes',
    category: 'LARGE / MODERATE / COLLAGEN POWDER',
    size: 'large',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'daily',
    duration: '30-day',
    productCodes: ['A6010', 'A6253'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6253', units: 30, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    defaultItems: 'large_powder_30day',
    kitDuration: '30-day'
  },

  // ✅ NEW 15-DAY ENTRY
  'large_moderate_powder_15day': {
    id: 'large_moderate_powder_15day',
    displayName: '(15-Day) Every Other Day Changes',
    category: 'LARGE / MODERATE / COLLAGEN POWDER',
    size: 'large',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'every-other-day',
    duration: '15-day',
    productCodes: ['A6010', 'A6253'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6253', units: 15, description: 'ABD Pad 7.5"x8" w/o Border' }
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    defaultItems: 'large_powder_15day',
    kitDuration: '15-day'
  },

  'large_moderate_powder_12day': {
    id: 'large_moderate_powder_12day',
    displayName: '(12-Day) 3 Dressing Changes Per Week',
    category: 'LARGE / MODERATE / COLLAGEN POWDER',
    size: 'large',
    drainage: 'Moderate',
    primaryType: 'collagen_powder',
    frequency: 'weekly',
    duration: '12-day',
    productCodes: ['A6010', 'A6446', 'A4452'],
    products: [
      { code: 'A6010', units: 30, description: 'Collagen Powder (1 Gram)' },
      { code: 'A6253', units: 12, description: 'ABD Pad 7.5"x8" w/o Border' },
    ],
    proPackPrimary: 'collagen_powder',
    proPackPrimarySize: null,
    proPackSecondary: 'ABD Pad 7.5"x8" w/o Border',
    defaultItems: 'large_powder_12day',
    kitDuration: '12-day'
  },
};